import { render, staticRenderFns } from "./ProjectDictItemModal.vue?vue&type=template&id=3fd853a7&scoped=true"
import script from "./ProjectDictItemModal.vue?vue&type=script&lang=js"
export * from "./ProjectDictItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd853a7",
  null
  
)

export default component.exports